import { getHeaders } from '../../../core/api';
import { host } from '../../../config';

export function postHotelFeedback(payload) {
  return fetch(`${host}/api/support/hotel/issue/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchHotel(id, payload) {
  return fetch(`${host}/api/hotel/${id}/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function postHotelUnsubscribe(id, payload) {
  return fetch(`${host}/api/hotel/${id}/unsubscribe/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}



// WEBPACK FOOTER //
// src/routes/feedback/modules/api.js